@if (cropSoilAnalysisData$ | async; as cropSoilAnalysisData) {
  @if (isSuccessResponse(cropSoilAnalysisData)) {
    @if (displayMode() === 'tga') {
      <div class="tga-card-container">
        <div class="tga-card-header">
          <h1>{{ 'TGA.Advice.Cultivation.BemWidgetTitle' | translate }}</h1>
          <button
            color="accent"
            mat-flat-button
            [disabled]="!isParticipatingInBem()"
            (click)="adviceButtonClick.emit()"
          >
            {{ 'TGA.Advice.Cultivation.ViewBemAdvice' | translate }}
          </button>
        </div>
        <div class="tga-card-content">
          <div class="tga-responsive-container">
            <div class="mobile-date">
              @if (latestCropSoilAnalysis) {
                {{ latestCropSoilAnalysis.sampleDate | date: 'mediumDate' : undefined : locale }}
              }
            </div>

            <!-- Mobile Results Table -->
            <div class="mobile-results-table">
              @for (type of ['Plant', 'Soil']; track type) {
                @if (
                  latestCropSoilAnalysis &&
                  ((type === 'Plant' &&
                    (latestCropSoilAnalysis.sampleNumber === 'Two' ||
                      latestCropSoilAnalysis.sampleNumber === 'Three')) ||
                    (type === 'Soil' &&
                      (latestCropSoilAnalysis.sampleNumber === 'One' ||
                        latestCropSoilAnalysis.sampleNumber === 'Three')))
                ) {
                  <div class="results-section">
                    <div class="section-label">
                      {{ 'BFP.UI.' + type | translate }}
                    </div>

                    <div class="results-row">
                      <div class="nutrient-labels">
                        <app-nutrient-label-column [hasSoilNitrate]="showSoilNitrate" [isPlant]="type === 'Plant'">
                        </app-nutrient-label-column>
                      </div>
                      <div class="nutrient-values">
                        <!-- Add a container for stacking elements -->
                        <div class="stacked-components">
                          <app-lab-result-column
                            [data]="latestCropSoilAnalysis"
                            [isPlant]="type === 'Plant'"
                            [hasSoilNitrate]="showSoilNitrate"
                          >
                          </app-lab-result-column>
                          <app-valuation-bar-column
                            [data]="latestCropSoilAnalysis"
                            [hasSoilNitrate]="showSoilNitrate"
                            [isPlant]="type === 'Plant'"
                          >
                          </app-valuation-bar-column>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
      </div>
    } @else {
      <mat-card class="lab-results-card">
        <mat-card-header class="table-header">
          <mat-card-title class="table-title">{{ 'BFP.UI.Analytical_res' | translate }}</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          @if (!isMobile) {
            <div class="container">
              <div class="grid-table">
                <!-- Header -->
                <div class="header-section">
                  <div class="param-header">
                    <span class="padding-8">{{ 'BFP.UI.Par' | translate }}</span>
                  </div>
                  <div class="analysis-header">{{ 'BFP.UI.Analytical_res' | translate }}</div>
                </div>

                <!-- Date values row -->
                <div class="date-values">
                  <div></div>
                  <div></div>
                  <div></div>
                  <div>
                    @if (data[0]; as analysis) {
                      {{ analysis.sampleDate | date: 'mediumDate' : undefined : locale }}
                    }
                  </div>
                  <div>
                    @if (data[1]; as analysis) {
                      {{ analysis.sampleDate | date: 'mediumDate' : undefined : locale }}
                    }
                  </div>
                  <div>
                    @if (data[2]; as analysis) {
                      {{ analysis.sampleDate | date: 'mediumDate' : undefined : locale }}
                    }
                  </div>
                  <div class="valuation-labels">
                    <div>{{ 'BFP.UI.Low' | translate }}</div>
                    <div>{{ 'BFP.UI.Normal' | translate }}</div>
                    <div>{{ 'BFP.UI.High' | translate }}</div>
                  </div>
                </div>
                <!-- Top Row: Plant Parameters (Bottom-Up) -->
                @if (latestCropSoilAnalysis) {
                  <div class="grid-row top-row">
                    <div class="grid-cell">
                      <app-label-column [resultType]="'Plant'"></app-label-column>
                    </div>
                    <div class="grid-cell">
                      <app-image-column [imgSrc]="topImg"></app-image-column>
                    </div>
                    <div class="grid-cell">
                      <app-nutrient-label-column
                        [hasSoilNitrate]="showSoilNitrate"
                        [isPlant]="true"
                      ></app-nutrient-label-column>
                    </div>
                    <div class="grid-cell"></div>
                    <div class="grid-cell has-value">
                      <app-lab-result-column
                        [data]="data[1]"
                        [isPlant]="true"
                        [hasSoilNitrate]="showSoilNitrate"
                      ></app-lab-result-column>
                    </div>
                    <div class="grid-cell has-value">
                      <app-lab-result-column
                        [data]="data[2]"
                        [isPlant]="true"
                        [hasSoilNitrate]="showSoilNitrate"
                      ></app-lab-result-column>
                    </div>
                    <div class="grid-cell">
                      <app-valuation-bar-column
                        [data]="data[2] ?? data[1]"
                        [hasSoilNitrate]="showSoilNitrate"
                        [isPlant]="true"
                      ></app-valuation-bar-column>
                    </div>
                  </div>

                  <!-- Bottom Row: Soil Parameters (Top-Down) -->
                  <div class="grid-row bottom-row">
                    <div class="grid-cell">
                      <app-label-column [resultType]="'Soil'"></app-label-column>
                    </div>
                    <div class="grid-cell">
                      <app-image-column [imgSrc]="bottomImg"></app-image-column>
                    </div>
                    <div class="grid-cell">
                      <app-nutrient-label-column
                        [hasSoilNitrate]="showSoilNitrate"
                        [isPlant]="false"
                      ></app-nutrient-label-column>
                    </div>
                    <div class="grid-cell has-value">
                      <app-lab-result-column
                        [data]="data[0]"
                        [isPlant]="false"
                        [hasSoilNitrate]="showSoilNitrate"
                      ></app-lab-result-column>
                    </div>
                    <div class="grid-cell"></div>
                    <div class="grid-cell has-value">
                      <app-lab-result-column
                        [data]="data[2]"
                        [isPlant]="false"
                        [hasSoilNitrate]="showSoilNitrate"
                      ></app-lab-result-column>
                    </div>
                    <div class="grid-cell">
                      <app-valuation-bar-column
                        [data]="data[2] ?? data[0]"
                        [hasSoilNitrate]="showSoilNitrate"
                        [isPlant]="false"
                      ></app-valuation-bar-column>
                    </div>
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="mobile-container">
              <div class="mobile-date">
                @if (latestCropSoilAnalysis) {
                  {{ latestCropSoilAnalysis.sampleDate | date: 'mediumDate' : undefined : locale }}
                }
              </div>

              <!-- Mobile Results Table -->
              <div class="mobile-results-table">
                @for (type of ['Plant', 'Soil']; track type) {
                  @if (
                    latestCropSoilAnalysis &&
                    ((type === 'Plant' &&
                      (latestCropSoilAnalysis.sampleNumber === 'Two' ||
                        latestCropSoilAnalysis.sampleNumber === 'Three')) ||
                      (type === 'Soil' &&
                        (latestCropSoilAnalysis.sampleNumber === 'One' ||
                          latestCropSoilAnalysis.sampleNumber === 'Three')))
                  ) {
                    <div class="results-section">
                      <div class="section-label">
                        {{ 'BFP.UI.' + type | translate }}
                      </div>

                      <div class="results-row">
                        <div class="nutrient-labels">
                          <app-nutrient-label-column [hasSoilNitrate]="showSoilNitrate" [isPlant]="type === 'Plant'">
                          </app-nutrient-label-column>
                        </div>
                        <div class="nutrient-values">
                          <!-- Add a container for stacking elements -->
                          <div class="stacked-components">
                            <app-lab-result-column
                              [data]="latestCropSoilAnalysis"
                              [isPlant]="type === 'Plant'"
                              [hasSoilNitrate]="showSoilNitrate"
                            >
                            </app-lab-result-column>
                            <app-valuation-bar-column
                              [data]="latestCropSoilAnalysis"
                              [hasSoilNitrate]="showSoilNitrate"
                              [isPlant]="type === 'Plant'"
                            >
                            </app-valuation-bar-column>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                }
              </div>
            </div>
          }
        </mat-card-content>
      </mat-card>
    }
  } @else {
    <!-- Error state -->
    @if (displayMode() === 'tga') {
      <div class="tga-card-container">
        <div class="tga-card-header">
          <h1>{{ 'TGA.Advice.Cultivation.BemWidgetTitle' | translate }}</h1>
          <button color="accent" mat-flat-button [disabled]="!isParticipatingInBem()" (click)="onAdviceButtonClick()">
            {{ 'TGA.Advice.Cultivation.ViewBemAdvice' | translate }}
          </button>
        </div>
        <div class="tga-card-content">
          @if (!isParticipatingInBem() || cropSoilAnalysisData?.status === 404) {
            <app-empty-widget [text]="'BFP.UI.Widget.EmptyWidgetText' | translate" />
          } @else {
            <agr-notification-empty
              [emptyDescription]="
                (cropSoilAnalysisData?.status
                  ? 'BFP.Validation.Backend.' + cropSoilAnalysisData.status
                  : 'BFP.Validation.Backend.404') + '.CropSoilAnalysis' | translate
              "
              [isEmpty]="true"
              [showEmptyAction]="false"
              emptyActionColor="primary"
            />
          }
        </div>
      </div>
    } @else {
      <mat-card class="error-card">
        <mat-card-content>
          <agr-notification-empty
            [emptyDescription]="
              (cropSoilAnalysisData?.status
                ? 'BFP.Validation.Backend.' + cropSoilAnalysisData.status
                : 'BFP.Validation.Backend.404') + '.CropSoilAnalysis' | translate
            "
            [isEmpty]="true"
            [showEmptyAction]="false"
            emptyActionColor="primary"
          />
        </mat-card-content>
      </mat-card>
    }
  }
} @else {
  <!-- Loading state -->
  @if (displayMode() === 'tga') {
    <div class="tga-card-container">
      <div class="tga-card-header">
        <h1>{{ 'TGA.Advice.Cultivation.BemWidgetTitle' | translate }}</h1>
        <button color="accent" mat-flat-button [disabled]="!isParticipatingInBem()" (click)="adviceButtonClick.emit()">
          {{ 'TGA.Advice.Cultivation.ViewBemAdvice' | translate }}
        </button>
      </div>
      <div class="tga-card-content">
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <span>{{ 'BFP.UI.Loading' | translate }}</span>
        </div>
      </div>
    </div>
  } @else {
    <mat-card class="loading-card">
      <mat-card-content>
        <div class="loading-container">
          <mat-spinner diameter="40"></mat-spinner>
          <span>{{ 'BFP.UI.Loading' | translate }}</span>
        </div>
      </mat-card-content>
    </mat-card>
  }
}
